import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Row } from 'antd';
import styled from 'styled-components';
import * as styles from './overview.module.css';
const Wrapper = styled.div`
  padding: var(--layout-01) var(--layout-01) var(--layout-02);
  padding-left: var(--left-spacing);
  overflow: auto;
  max-height: calc(100vh - 144px);
  min-height: 400px;
`;
const Main = styled(Col)`
  padding-right: var(--spacing-05);
`;
const Right = styled(Col)`
  overflow: hidden;
  padding-bottom: var(--spacing-03);
  background: var(--white-100);
  min-width: 320px !important;
  min-height: 1px;
  transition: top var(--animation-duration-medium) ease;
  border: 1px solid var(--cool-gray-20);
  border-radius: var(--border-radius-small);
  box-shadow: none;
`;
export const Layout = ({ main, right })=>/*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsxs(Row, {
            align: "top",
            gutter: [
                0,
                0
            ],
            children: [
                /*#__PURE__*/ _jsx(Main, {
                    span: 16,
                    lg: 14,
                    className: styles.main,
                    children: main
                }),
                /*#__PURE__*/ _jsx(Right, {
                    span: 8,
                    lg: 10,
                    children: right
                })
            ]
        })
    });
